import { PlusIcon } from "@phosphor-icons/react/Plus";
import { Button } from "@freightsimple/ui-core/Controls/Button";

interface AddBankAccountButtonProps {
  onClick: () => void;
}

export function BankAccountsAddButton(props: AddBankAccountButtonProps) {
  return (
    <Button
      primary
      size="large"
      icon={PlusIcon}
      iconWeight="fill"
      onClick={props.onClick}
    >
      Add New Bank Account
    </Button>
  );
}
